let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kpzlp")).then(() => parcelRequire('i34K4'));